import { Navigate, Outlet } from 'react-router-dom';

// project imports
import { usePermission } from './usePermission';

// ==============================|| AUTH GUARD - REQUIRE PERMISSION ||============================== //
// Route-level gate: wrap a route's element, or use as a layout route with <Outlet/> children.
// usage as element:     <RequirePermission code="clientes.create"><ClienteFormPage/></RequirePermission>
// usage as layout route: { element: <RequirePermission code="usuarios.read" />, children: [...] }

export default function RequirePermission({ code, children }) {
  const hasPermission = usePermission();

  if (!hasPermission(code)) {
    return <Navigate to="/403" replace />;
  }

  return children ?? <Outlet />;
}
